import ComsobaseMaterialsActions from "./components/actions/index.vue";
import ComsobaseMaterialsInfo from "./components/info/index.vue";
import SimpleBreadcrumbs from "@/modules/pages/components/simple-breadcrumbs/index.vue"

export default {
    name: "CosmobaseStudyPage",
    props: {},
    emits: [],
    components: {
      ComsobaseMaterialsActions,
      ComsobaseMaterialsInfo,
      SimpleBreadcrumbs
    },
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {},
    methods: {}
}